import toast from 'react-hot-toast';
import { useState } from 'react';
import { Modal, Button, Loader } from '../../../../UiKit';
import { EmptyState } from '../../../commons';
import { InvalidSearchImg } from '../../../../images/images';
import { MultiMedia } from '../../../../UiKit/multimedia/multimedia';
import { useQueryCall } from '../../../../api/react-client';
import { lifelineEndPoints } from '../../../../api/end-points';

export function OrderIssuesImages({ orderId, userId }) {
  const [isVisible, setIsVisible] = useState(false);

  if (!orderId && !userId) return null;

  return (
    <>
      {/* eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions */}
      <p className='colorGreen' onClick={() => setIsVisible(true)}>
        View Complaint Images
      </p>
      {isVisible && (
        <OrderIssuesImagesModal
          isVisible={isVisible}
          handleClose={() => setIsVisible(false)}
          orderId={orderId}
          userId={userId}
        />
      )}
    </>
  );
}

function OrderIssuesImagesModal({ orderId, userId, isVisible, handleClose }) {
  const [offset, setOffset] = useState(0);
  const queryKey = [
    'lifeline_apis',
    'chat_media',
    'get_images',
    orderId,
    userId,
    offset,
  ];
  const getOrderIssueImgsEndPoint = `${lifelineEndPoints?.GET_CHAT_MEDIA}?order_id=${orderId}&customer_id=${userId}&offset=${offset}&type=complaint`;
  const { data, isLoading } = useQueryCall(
    { keepPreviousData: true },
    getOrderIssueImgsEndPoint,
    queryKey,
  );
  let mediaList =
    data?.media_data?.map((img) => ({
      src: img?.media_url,
      type: img?.media_type,
      upload_method: img?.upload_method || 'Unknown',
    })) || [];

  return (
    <Modal
      isMaxContent
      isVisible={isVisible}
      type='large'
      title='View complaint images/videos'
      handleClose={handleClose}
      component={
        isLoading ? (
          <Loader />
        ) : data?.isError ? (
          <EmptyState
            img={InvalidSearchImg}
            heading={data?.message || 'Something went wrong'}
          />
        ) : (
          <>
            {data?.media_data?.length === 0 && (
              <EmptyState
                img={InvalidSearchImg}
                heading='Customer has not submitted any images'
              />
            )}
            <MultiMedia
              images={mediaList}
              mediaStyle={{
                display: 'flex',
                justifyContent: 'center',
              }}
              title='Complaint Images/Videos'
              showUploadMethod={true}
            />
            {data?.has_more || offset > 0 ? (
              <div
                css={`
                  display: flex;
                  justify-content: center;
                  align-items: center;
                  gap: 1rem;
                `}
                className='tw-mt-[2rem]'
              >
                <Button
                  outline
                  disabled={isLoading}
                  onClick={() => {
                    if (offset === 0)
                      return toast.error('You are already at the end');
                    if (offset < 5) {
                      setOffset(0);
                    } else {
                      setOffset((o) => o - 5);
                    }
                  }}
                  title={'back'}
                />
                <div>
                  {offset} - {offset + 5}
                </div>
                <Button
                  outline
                  disabled={isLoading}
                  onClick={() => {
                    if (data?.has_more) {
                      setOffset((o) => o + 5);
                    } else {
                      toast.error('No more images to show');
                    }
                  }}
                  title={'next'}
                />
              </div>
            ) : null}
          </>
        )
      }
    />
  );
}
